import { Wrapper } from './styles';
import { FrayedDividerProps } from './types';

const FrayedDivider = ({
	className,
	isFlipped = false,
	src = '/_n/images/schools/schools-torn-paper.webp',
}: FrayedDividerProps) => {
	return <Wrapper className={className} isFlipped={isFlipped} src={src} />;
};

export default FrayedDivider;
